import mrApi from './mrApi';
import loadScript from '@utilities/loadScript';

export async function loadAfterpayLib() {
  const scriptId = 'afterpay-script-tag';
  const url = 'https://js.afterpay.com/afterpay-1.x.js';
  await loadScript(url, {
    async: true,
    'data-analytics-enabled': true,
    id: scriptId,
  });
}

export async function loadAfterPayPaymentScript() {
  let url = 'https://portal.afterpay.com/afterpay.js';
  if (process.env.NODE_ENV !== 'production') {
    url = 'https://portal.sandbox.afterpay.com/afterpay.js';
  }
  const scriptId = 'afterpay-payment-script-tag';
  await loadScript(url, {
    async: true,
    'data-analytics-enabled': true,
    id: scriptId,
  });
}

export async function getCheckoutToken(params) {
  return mrApi.post('/api/afterpay/getCheckoutToken', params);
}

export async function createPaymentMethod(params) {
  return mrApi.post('/api/afterpay/createPaymentMethod', params);
}

export async function setupBillingAgreementApproval(params) {
  return mrApi.post('/api/afterpay/setupBillingAgreementApproval', params);
}

export async function getScheduledPaymentToken(params) {
  return mrApi.post('/api/afterpay/getScheduledPaymentToken', params);
}